import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogCandidateViewedTabDetails_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';

type Fragments = {
  activityLog: ActivityLogCandidateViewedTabDetails_ActivityLogFragment;
};

const ActivityLogCandidateViewedTabDetails: FCWithFragments<Fragments> = ({ activityLog }) => {
  // eslint-disable-next-line no-underscore-dangle
  if (!activityLog.details || activityLog.details.__typename !== 'ActivityLogCandidateViewedTabDetails') {
    throw new Error('ActivityLogCandidateViewedTabDetails: details is not ActivityLogCandidateViewedTabDetails');
  }

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.viewedTab"
      actionLabelValues={{ tabName: activityLog.details.tabName }}
    />
  );
};

ActivityLogCandidateViewedTabDetails.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogCandidateViewedTabDetails_activityLog on ActivityLog {
      id
      details {
        ... on ActivityLogCandidateViewedTabDetails {
          __typename
          tabName
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogCandidateViewedTabDetails;
